import { useState } from "react";
import { Link } from "react-router-dom";
import { PUBLIC_OFFERS, SUBSCRIPTION_PRICES } from "@/data/offers";

export function Offers() {
  const [annual, setAnnual] = useState(false);
  return (
    <>
      <div className="sc-interval" role="group" aria-label="Billing interval">
        <button aria-pressed={!annual} onClick={() => setAnnual(false)}>
          Monthly
        </button>
        <button aria-pressed={annual} onClick={() => setAnnual(true)}>
          Annual
        </button>
      </div>
      <div className="sc-offers">
        {PUBLIC_OFFERS.map((plan) => (
          <article className={`sc-offer ${plan.accent ? "sc-offer-featured" : ""}`} key={plan.name}>
            <div className="sc-offer-title">
              <h3>{plan.name}</h3>
              {plan.accent && <span className="sc-tag">For clubs</span>}
            </div>
            <p className="sc-price">
              {plan.name === "Club Unlimited" && annual
                ? `USD ${SUBSCRIPTION_PRICES.club.annual}`
                : plan.price}
            </p>
            <p className="sc-secondary">
              {plan.name === "Club Unlimited"
                ? annual
                  ? `per year · USD ${SUBSCRIPTION_PRICES.club.monthly}/month also available`
                  : `per month · USD ${SUBSCRIPTION_PRICES.club.annual}/year also available`
                : plan.period}
            </p>
            <ul>
              {plan.features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
            {plan.name === "Free" ? (
              <Link className="sc-button sc-button-primary" to="/login">
                Start free
              </Link>
            ) : (
              <Link className="sc-button" to="/login" state={{ from: { pathname: "/upgrade" } }}>
                Create a free account
              </Link>
            )}
          </article>
        ))}
      </div>
      <p className="sc-note">
        Prices in USD, plus tax where applicable. Pay in USD or your local currency at Stripe’s
        rate, including its 2–4% conversion fee, when paid plans become available.
      </p>
    </>
  );
}
